
import param from '@/utils/url/param'
import mixins from './mixins.js'
export default {
  name: 'layout-footer',
  mixins: [mixins],
  props: {
    theme: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    site() {
      return site
    },
    redes() {
      return redes
    }
  },
  methods: {
    openWhats() {
      return `https://api.whatsapp.com/send${param({
        phone: '55' + site.whatsapp.replace(/[^0-9]+/g, ''),
        text: 'Quero marcar uma consulta pelo whatsapp'
      })}`
    }
  }
}
